
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"35.078","height":"33.498","viewBox":"0 0 35.078 33.498"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-557.162 -379.306)","stroke":"#55534f","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}},[_c('g',{attrs:{"data-name":"Group 982","fill":"#fff"}},[_c('path',{attrs:{"data-name":"Line 67","d":"M584.053 396.055h7.187"}}),_c('path',{attrs:{"data-name":"Line 68","d":"M558.162 396.055h19.378"}}),_c('path',{attrs:{"data-name":"Line 69","d":"M568.111 383.562h23.129"}}),_c('path',{attrs:{"data-name":"Line 70","d":"M558.162 383.562h3.436"}}),_c('path',{attrs:{"data-name":"Line 71","d":"M574.4 408.548h16.841"}}),_c('path',{attrs:{"data-name":"Line 72","d":"M558.162 408.548h9.725"}})]),_c('circle',{attrs:{"data-name":"Ellipse 86","cx":"3.256","cy":"3.256","r":"3.256","transform":"translate(577.541 392.799)","fill":"none"}}),_c('circle',{attrs:{"data-name":"Ellipse 87","cx":"3.256","cy":"3.256","r":"3.256","transform":"translate(561.599 380.306)","fill":"none"}}),_c('circle',{attrs:{"data-name":"Ellipse 88","cx":"3.256","cy":"3.256","r":"3.256","transform":"translate(567.887 405.292)","fill":"none"}})])])
          )
        }
      }
    